const forEach = (element, processor) => {
  if (!element) {
    return 0;
  }

  if (element.length == null || element === window) {
    const result = processor(element, 0);

    return result || result == null ? 1 : 0;
  }

  let processed = 0;

  for (let i = 0; i < element.length; i++) {
    if (element[i]) {
      const result = processor(element[i], processed);

      if (result || result == null) {
        processed++;
      }
    }
  }

  return processed;
};

export default forEach;



export const map = (element, processor) => {
  const results = [];

  forEach(element, (el, index) => {
    results.push(processor(el, index));
  });

  return results;
};



// WEBPACK FOOTER //
// ./src/lib/dom/iterate.js